import React, { Component } from 'react'
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
export default class Customers extends Component {

    state = {
        data: [], //กำหนดค่าเริ่มต้นเป็น Array ว่าง เพื่อรอรับค่าต่างๆ
    }

    onTextChange = (e) => { //เมื่อมีการพิมพ์ค้นหา ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่งค่าที่ต้องการค้นหาไปที่ไฟล์ search.php
        Axios.get('http://localhost/PHP/search.php?id=' + e.target.value)
            .then((res) => {
                this.setState({ data: res.data })
            })
    }


    delete = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
        Axios.get('http://localhost/PHP/delete.php?id=' + id)
            .then((res) => {
                this.getdata()
            })
    }

    getdata = () => { //เป็นฟังก์ชั่นไว้เรียกใช้สำหรับดึงข้อมูลมาทั้งหมด
        Axios.get('http://localhost/PHP/select.php')
            .then((res) => {
                this.setState({ data: res.data })
            })
    }

    componentDidMount() { //เป็นฟังก์ชั่นชอง react โดนเฉพาะ โดยฟังก์ชั่นนี้จะถูกเรียกใช้งานครั้งแรกเสมอเมื่อมีการโหลด component นี้
        this.getdata()
    }

    render() {
        return (
            <div className="container">
                <MDBCard>
                    <MDBCardBody>

                        <h1>รายชื่อสมาชิก</h1>

                        <div className="text-right">
                            <input onChange={this.onTextChange} placeholder="ค้นหาชื่อ" />
                        </div>


                        <MDBTable small style={{ border: "1px" }} border width="100%">
                            <MDBTableHead  >
                                <tr  >
                                    <th>Firstname</th>
                                    <th>Lastname</th>
                                    <th>Age</th>
                                    <th>sex</th>
                                    <th>จัดการ</th>
                                </tr>
                            </MDBTableHead>


                            <MDBTableBody>
                                {this.state.data.map((data) => {
                                    return <tr>
                                        <td>{data.name}</td>
                                        <td>{data.lname}</td>
                                        <td>{data.age}</td>
                                        <td>{data.sex}</td>
                                        <td>
                                            <Link to={{ pathname: "/AddCustomers/", data: data }} >
                                                <MDBBtn size="sm" color="primary"><MDBIcon far icon="edit" /> แก้ไข</MDBBtn>
                                            </Link>
                                            <MDBBtn size="sm" color="pink" onClick={() => this.delete(data.id)} ><MDBIcon far icon="trash-alt" /> ลบ</MDBBtn>
                                        </td>
                                    </tr>
                                })}
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCardBody>
                </MDBCard>
            </div>
        )
    }
}
